import {createBridgeModel} from '../design/configurator/room/bridge-model';
import {createCustomLayout} from '../design/configurator/room/custom-layout';
import {INITIAL_ROOM} from '../design/configurator/room/model';
import {ERNST_SPAN,ERNST_DEPTH} from './ernst-layout';

/** Same configuration and geometry as Design Studio. Never shrink it to a photo. */
export function createErnstModel() {
 const room={...INITIAL_ROOM,width:ERNST_SPAN,depth:ERNST_DEPTH};
 const bed=createCustomLayout(room,'A','rosemary','daydreamer-ernst');
 return createBridgeModel(bed,room);
}
